import {Component, Injectable, OnInit} from '@angular/core';
// @ngrx
import { Store } from '@ngrx/store';


import * as AuthenticateReducer from '@store/auth/reducers';
import {RefreshAuthState, SignOut, UpdateAuthUser} from '@store/auth/actions';
import {AuthFacade} from '@app/facades/auth/authFacade';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {PermissionFacade} from '@facades/permission/permissionFacade';
import {User} from '@models/user';
import * as SpinnerReducer from '@store/spinner/reducers';
import {StartSpinner, StopSpinner} from '@store/spinner/actions';
import {PusherService} from '@services/pusher/pusher.service';
import {filter} from '@node_modules/rxjs/operators';
import {NavigationEnd} from '@node_modules/@angular/router';
import {UrlService} from '@services/url/url.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

@Injectable()
export class AppComponent implements OnInit {
  user: User;
  previousUrl: string = null;
  currentUrl: string = null;

  constructor(
    private router: Router,
    private authStore: Store<AuthenticateReducer.AuthState>,
    private spinnerStore: Store<SpinnerReducer.SpinnerState>,
    private authFacade: AuthFacade,
    private urlService: UrlService,
  ) {
    this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    );
    this.authStore.dispatch(new RefreshAuthState());
      router.events.subscribe( (event) => {

          if (event instanceof NavigationStart && this.user.role !== 'super_admin') {
              // this.beforeRoute(event.url.split('?')[0]);
          }
      });
  }
  ngOnInit() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.urlService.setPreviousUrl(this.previousUrl);
    });
  }

  beforeRoute(page) {
      page = page ? page : this.router.url.split('?')[0];
      if (this.authFacade.pageNeedAuth(page)) {
          console.log('with auth');
          console.log(PermissionFacade.checkPermissionsToAccessPage(page, this.user));
          console.log(page);
        if (page !== '/dashboard' && !PermissionFacade.checkPermissionsToAccessPage(page, this.user)) {
            console.log(AuthFacade.getAuthStatus());
            console.error('You dont have permissions to visit page ' + page);
            this.authFacade.checkAuthStatusAndRedirect(page);
        }
    } else {
        console.log('not auth');
        this.authStore.dispatch(new SignOut(this.authFacade, false));
    }

    // if (this.router.url === '/auth/login' || this.router.url === '/auth/register') {
    //     this.authStore.dispatch(new SignOut(this.authFacade, false));
    // }

    this.spinnerStore.dispatch(new StopSpinner());
  }
}
